'use strict'

const shops =  {
    el: {
        json: {},
        shopsSearch: [],
        currentFilters: {
            letter: "*",
            cat: "*",
            subcat: []
        },
        height: 0,
    },

    init: function() {
        if(document.querySelector('.shops_results')) {
            const shop_results = document.querySelector('.shops_results');
            
            shops.events();
            shops.el.json = abecedaireBoutiques;
            // shops.createFilters();
            if (!shop_results.classList.contains('responsive-display')){
                shops.createLogos();
            }
            shops.createGroups();
            shops.createShops();
            shops.catsWidth();
        }

        // xBrowser requestAnimationFrame()
        var lastTime = 0;
        var vendors = ['ms', 'moz', 'webkit', 'o'];
        for (var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
            window.requestAnimationFrame = window[vendors[x]+'RequestAnimationFrame'];
            window.cancelAnimationFrame = window[vendors[x]+'CancelAnimationFrame'] || window[vendors[x]+'CancelRequestAnimationFrame'];
        }
        if (!window.requestAnimationFrame)
            window.requestAnimationFrame = function(callback, element) {
                var currTime = new Date().getTime();
                var timeToCall = Math.max(0, 16 - (currTime - lastTime));
                var id = window.setTimeout(function() { callback(currTime + timeToCall); }, timeToCall);
                lastTime = currTime + timeToCall;
                return id;
            };
        if (!window.cancelAnimationFrame)
            window.cancelAnimationFrame = function(id) {
                clearTimeout(id);
            };
    },

    // création des boutiques (logos) à partir du JSON. Cette liste n'est affichée seulement au chargement de la page
    createLogos: function () {
        let json = shops.el.json;
        let logosList = document.querySelector('.shops_logos');
        json.shops.forEach(shop => {
            // au chargement, seule les boutiques ayant le paramètre home: true apparaissent
            if ( shop.home === true ) {
                let newShop = document.createElement('div');
                newShop.classList.add('shops_item');
                newShop.setAttribute('data-in-view', '');
                newShop.innerHTML = '<a class="shops_logo" href="' + shop.link + '" style="background-image: url(' + shop.logo + ')"></a>';
                logosList.appendChild(newShop);
            }
        });
    },

    // création des groupes de lettre à partir du JSON
    createGroups: function () {
        let results = document.querySelector('.shops_results');
        let json = shops.el.json;
        let groups = [];
        json.shops.forEach(shop => {
            groups.push(shop.letter);
        });
        // new array to remove double values
        let letters = [...new Set(groups)];
        letters.forEach(letter => {
            let group = document.createElement('div');
            group.classList.add('shops_group');
            group.setAttribute('data-group', letter);
            group.innerHTML = '<div class="shops_group-letter">' + letter + '</div><ul class="shops_group-list"></ul>';
            results.appendChild(group);
        });
    },

    // création des boutiques à partir du JSON
    createShops: function () {
        let json = shops.el.json;
        json.shops.forEach(shop => {
            let shopList = document.querySelector('.shops_group[data-group="' + shop.letter + '"] .shops_group-list');
            let newShop = document.createElement('li');
            newShop.setAttribute('data-search', shop.nom);
            newShop.setAttribute('data-in-view', '');
            // newShop.setAttribute('data-in-view', '');
            newShop.classList.add('shop');

            const listLetter = document.getElementsByClassName('shops_letters')[0];
            for(let l=0;l< listLetter.children.length;l++){
                if(shop.letter === listLetter.children[l].textContent ){
                    listLetter.children[l].classList.add('with_content');
                }
            }

            let cats = '';
            if ( shop.cat ) {
                shop.cat.forEach(i => {
                    for (let value of Object.keys(i)) {
                        cats === '' ? cats = value : cats += ',' + value;
                    }
                });
                newShop.setAttribute('data-cat', cats);
            }
            
            let subcats = '';
            if( shop.subcat ) {
                shop.subcat.forEach(i => {
                    for (let value of Object.keys(i)) {
                        subcats === '' ? subcats = value : subcats += ',' + value;
                    }
                });
                newShop.setAttribute('data-subcat', subcats);
            }

            // au chargement, seule les boutiques ayant le paramètre home: true apparaissent
            shop.home === true ? newShop.classList.add('active') : '';

            // picto new
            shop.new === true ? newShop.classList.add('new'): '';

            // picto alert
            shop.alert === true ? newShop.classList.add('alert') : '';

            // add link and name
            newShop.innerHTML = '<a href="' + shop.link + '">' + shop.nom + '</a>';

            shopList.appendChild(newShop);

            // si la boutique propose plusieurs marques
            if ( shop.marques.length > 0 ) {
                shop.marques.forEach(function(mark) {
                    let newMark = document.createElement('li');
                    newMark.setAttribute('data-search', shop.nom);
                    newMark.setAttribute('data-cat', cats);
                    newMark.setAttribute('data-subcat', subcats);
                    newMark.setAttribute('data-in-view', '');
                    newMark.classList.add('marque');
                    newMark.innerHTML = mark;
                    shopList.appendChild(newMark);
                });
            }
        });

        shops.displayActiveGroups();
    },

    // au chargement de la page on affiche seulement les boutiques qui ont le paramètre home à true
    displayActiveGroups: function() {
        let items = document.querySelectorAll('.shops_group-list li.active');
        if ( items ) {
            items.forEach(item => {
                if ( item.classList.contains('active')) {
                    item.parentElement.parentElement.classList.add('active');
                }
            });
        }
    },

    // création des événements au click
    events: function() {
        let letters = document.querySelectorAll('.shops_letterBtn');
        const shop_results = document.querySelector('.shops_results');
        if(letters) {
            letters.forEach(function(btn) {
                btn.addEventListener('click', function() {
                    if (!shop_results.classList.contains('responsive-display')){
                        document.querySelector('.shops_logos').classList.add('hide');
                    }else{
                        document.querySelector('.shops_logos-mobile').classList.add('hide');
                    }
                    let letter = btn.dataset.letter;
                    shops.letter(letter);
                    shops.noShopMsg();
                });
            });
        }

        let categories = document.querySelectorAll('.shops_category-btn');
        if(categories) {
            categories.forEach(function(btn) {
                btn.addEventListener('click', function() {
                    if (!shop_results.classList.contains('responsive-display')){
                        document.querySelector('.shops_logos').classList.add('hide');
                    }else{
                        document.querySelector('.shops_logos-mobile').classList.add('hide');
                    }
                    let category = btn.dataset.cat;
                    shops.category(category);
                    shops.noShopMsg();
                });
            });
        }

        let input = document.querySelector('.shops_search-input');
        if (input) {
            input.addEventListener('keyup', function(event) {
                document.querySelector('.shops_logos').classList.add('hide');
                if (event.target.value != '')
                    shops.search(event.target.value);
                else {
                    shops.toggleAllGroups(true);
                    shops.toggleAllShops(true);
                    if(document.querySelector('.shops_results.hide'))
                        document.querySelector('.shops_results.hide').classList.remove('hide');
                }
            });
        }

        let controls = document.querySelectorAll('.shops_controls button');
        if(controls) {
            controls.forEach(function(btn) {
                btn.addEventListener('click', function() {
                    shops.scroll(btn);
                });
            });
        }
    },

    // filtre par lettre
    letter: function(filter) {
        let activeLetter = document.querySelector('.shops_letterBtn.active');
        if(activeLetter)
            activeLetter.classList.remove('active');

        let letter = document.querySelector('.shops_letterBtn[data-letter="' + filter + '"]');
        if(letter)
            letter.classList.add('active');
        
        if(document.querySelector('.shops_results.hide'))
            document.querySelector('.shops_results.hide').classList.remove('hide');

        shops.updateFilters();
    },

    // filtre par catégorie
    category: function(category) {
        let subcats = document.querySelector('.shops_subcategories');
        let activeCat = document.querySelector('.shops_category.active');
        if(activeCat) {
            activeCat.classList.remove('active');
            if(activeCat.querySelector('.shops_subcats')) {
                subcats.innerHTML = '';
            } 
        }
        
        let cat = document.querySelector('.shops_category-btn[data-cat="' + category + '"]');
        if(cat)
            cat.parentElement.classList.add('active');
            let subCatsContainer = document.querySelector('.shops_category.active .shops_subcats');
            if( subCatsContainer ) {
                subCatsContainer.querySelectorAll('.shops_subcat').forEach(function(i) {
                    let clone = i.cloneNode(true);
                    subcats.appendChild(clone);
                });

                let subcategories = subcats.querySelectorAll('.shops_subcat');
                if(subcategories) {
                    subcategories.forEach(function(btn) {
                        btn.addEventListener('click', function() {
                            let subcat = btn.dataset.subcat;
                            shops.subcategory(subcat);
                        });
                    });
                }
            }

        shops.updateFilters();
    },

    // filtre par sous-catégorie
    subcategory: function(sub) {
        let subcat = document.querySelector('.shops_subcategories .shops_subcat[data-subcat="' + sub + '"]');
        subcat.classList.contains('active') ? subcat.classList.remove('active') : subcat.classList.add('active');
        shops.updateFilters();
    },

    // mise à jour des filtres cliqués (lettre + catégorie + sous-catégorie) || la recherche est gérée à part plus bas
    updateFilters: function() {
        let activeLetter = document.querySelector('.shops_letterBtn.active');
        if ( activeLetter ) {
            let letter = activeLetter.dataset.letter;
            shops.el.currentFilters.letter = letter;
        } else {
            shops.el.currentFilters.letter = '*';
        }

        let activeCat = document.querySelector('.shops_category.active .shops_category-btn');
        activeCat ? shops.el.currentFilters.cat = activeCat.dataset.cat : shops.el.currentFilters.cat = "*";

        let activeSubCat = document.querySelectorAll('.shops_subcat.active');
        if ( activeSubCat ) {
            shops.el.currentFilters.subcat = [];
            activeSubCat.forEach(subcat => {
                shops.el.currentFilters.subcat.push(subcat.dataset.subcat);
            });
        }

        shops.showShops();
    },
    
    // afficher les boutiques en fonction des filtres choisis (lettre + catégorie + sous-catégorie) || la recherche est gérée à part plus bas
    showShops: function() {

        let letter = shops.el.currentFilters.letter,
            cat = shops.el.currentFilters.cat,
            subcat = shops.el.currentFilters.subcat;

        //
        // si j'ai un moment je refactoriserai ces 4 conditions en plus beau :-)
        //

        if ( letter === '*' && cat === '*' ) {
            // si aucun filtre n'est choisi, on affiche tout
            shops.toggleAllGroups(true);
            shops.toggleAllShops(true);

        } else if ( letter != '*' && cat != '*' ) {
            // plusieurs goupe de lettre et catégories ont été sélectionné
            shops.toggleAllGroups(false);
            let group  = document.querySelector('.shops_group[data-group="' + letter + '"]');
            if(group)
                group.classList.add('active');

            shops.toggleAllShops(false);
            let boutiques = document.querySelectorAll('.shops_group-list > li');
            boutiques.forEach(boutique => {
                if ( boutique.dataset.cat.indexOf(cat) != -1 ) {
                    if ( subcat.length === 0 ) {
                        boutique.classList.add('active');
                    } else {
                        subcat.forEach(filter => {
                            if (boutique.dataset.subcat.indexOf(filter) != -1 ) {
                                boutique.classList.add('active');
                            }
                        });
                    }
                }
            });

        } else if ( letter != '*' && cat === '*' ) {
            // un groupe de lettre est sélectionné mais toutes les catégories
            shops.toggleAllGroups(false);
            shops.toggleAllShops(true);
            let group  = document.querySelector('.shops_group[data-group="' + letter + '"]');
            if(group)
                group.classList.add('active');
            
        } else if ( letter === '*' && cat != '*' ) { // une catégorie de filtre est sélectionnée mais toutes les catégories
            shops.toggleAllGroups(false);
            shops.toggleAllShops(false);
            let boutiques = document.querySelectorAll('.shops_group-list > li');
            boutiques.forEach(boutique => {
                if ( boutique.dataset.cat.indexOf(cat) != -1 ) {
                    if ( subcat.length === 0 ) {
                        boutique.classList.add('active');
                        boutique.parentElement.parentElement.classList.add('active');
                    } else {
                        subcat.forEach(filter => {
                            if (boutique.dataset.subcat.indexOf(filter) != -1 ) {
                                boutique.classList.add('active');
                                boutique.parentElement.parentElement.classList.add('active');
                            }
                        });
                    }
                }
            });
        }

        shops.noShopMsg();
    },

    // mise en place (si besoin) d'une scrollbar sur la liste des catégories
    catsWidth: function() {
        let catsList = document.querySelector('.shops_categories');

        if(catsList) {
            let catsBtn = catsList.querySelectorAll('.shops_category');
            let catsWidth = 40;
            catsBtn.forEach(btn => {
                catsWidth = catsWidth + btn.offsetWidth + 20;
            });
            
            window.matchMedia("(max-width: 1099px)").matches ? catsList.style.width = catsWidth + 'px' : '';
        }
    },

    // filtre depuis l'input de recherche par autocomplétion
    search: function(value) {
        // click on ALL Letter if not active
        let allLetter = document.querySelector('.shops_letterBtn[data-letter="*"]');
        allLetter.classList.contains('active') ? true : allLetter.click();
        
        // click on ALL Category if not active
        let allCategory = document.querySelector('.shops_category-btn[data-cat="*"]');
        if ( allCategory )
            allCategory.parentElement.classList.contains('active') ? true : allCategory.click();

        let json = shops.el.json;
        shops.el.shopsSearch = [];
        let shopsSearch = shops.el.shopsSearch;
        
        json.shops.forEach(shop => {
            let nom = shop.nom.toLowerCase();
            if (nom.indexOf(value.toLowerCase()) !== -1) {
                shopsSearch.push(shop);
            } else {
                document.querySelector('.shops_results').classList.add('hide');
                document.querySelector('.shops_controls').classList.add('hide');
                document.querySelector('.shops_noResults').classList.remove('hide');
            }
        });

        if (shopsSearch.length > 0) {
            if(document.querySelector('.shops_results.hide'))
                document.querySelector('.shops_results.hide').classList.remove('hide');
            if(document.querySelector('.shops_controls.hide'))
                document.querySelector('.shops_controls.hide').classList.remove('hide');
            
            document.querySelector('.shops_noResults').classList.add('hide');
            
            // hide all items and groups
            shops.toggleAllGroups(false);
            shops.toggleAllShops(false);

            shopsSearch.forEach(shop => {
                document.querySelector('[data-search="' + shop.nom + '"]').classList.add('active');
                document.querySelector('[data-search="' + shop.nom + '"]').parentElement.parentElement.classList.add('active');
            });
        } else {
            // show all items
            shops.toggleAllGroups(true);
            shops.toggleAllShops(true);
        }
        // shops.noShopMsg();
    },

    // affichage (ou non) des groupes de lettres
    toggleAllGroups: function(toggle) {
        let groups = document.querySelectorAll('.shops_group');
        if (groups)
            groups.forEach(group => {
                toggle === false ? group.classList.remove('active') : group.classList.add('active');
            });
    },

    // affichage (ou non) des boutiques
    toggleAllShops: function(toggle) {
        let items = document.querySelectorAll('li[data-search]');
        if (items)
            items.forEach(item => {
                toggle === false ? item.classList.remove('active') : item.classList.add('active');
            });
    },

    // si aucun résultat, affichage d'un message
    noShopMsg: function() {
        // ajout d'un message si aucun résultat
        let activeItems = document.querySelectorAll('.shops_results .shops_group.active .active');
        let results = document.querySelector('.shops_results');
        let msg = document.querySelector('.shops_noResults');
        let controls = document.querySelector('.shops_controls');

        if (activeItems.length > 0) {
            results.classList.remove('hide');
            controls.classList.remove('hide');
            msg.classList.add('hide');
        } else {
            results.classList.add('hide');
            controls.classList.add('hide');
            msg.classList.remove('hide');
      
        } 
    },

    // scroll horizontal
    scroll: function (btn) {
        let results = document.querySelector('.shops_resultsWrap'),
            columnWidth = document.querySelector('.shops_group-list > li').offsetWidth,
            gap = 0;
            
        if ( !btn.hasAttribute('disabled') ) {
            if ( document.querySelector('.shops_results').classList.contains('hide') ) {
                // dans le cas où les logos sont affichés
                btn.dataset.controls === 'prev' ? shops.tween(results.scrollLeft, results.scrollLeft - 153, 500, shops.easeOutCubic) : shops.tween(results.scrollLeft, results.scrollLeft + 153, 500, shops.easeOutCubic);
            } else {
                // dans le cas où la liste des boutiques texte est affichée
                window.matchMedia("(max-width: 1023px)").matches ? gap = 20 : gap = 40;
                let delta = columnWidth + gap;
                btn.dataset.controls === 'prev' ? shops.tween(results.scrollLeft, results.scrollLeft - delta, 500, shops.easeOutCubic) : shops.tween(results.scrollLeft, results.scrollLeft + delta, 500, shops.easeOutCubic);
            }

            setTimeout(() => {
                let prev = document.querySelector('.shops_controls [data-controls="prev"]'),
                    next = document.querySelector('.shops_controls [data-controls="next"]');

                if ( results.scrollLeft === 0 ) {
                    prev.setAttribute('disabled', '');
                    next.removeAttribute('disabled');
                } else if ( results.scrollWidth - results.offsetWidth <= results.scrollLeft ) {
                    next.setAttribute('disabled', '');
                    prev.removeAttribute('disabled');
                } else {
                    prev.removeAttribute('disabled');
                    next.removeAttribute('disabled');
                }
            }, 501);
        }
    },

    // scroll animations
    tween: function (start, end, duration, easing) {
        let container = document.querySelector('.shops_resultsWrap'),
            delta = end - start,
            startTime;
        if (window.performance && window.performance.now) {
            startTime = performance.now();
        }
        else if (Date.now) {
            startTime = Date.now();
        }
        else {
            startTime = new Date().getTime();
        }
        let tweenLoop = function (time) {
            let t = (!time ? 0 : time - startTime);
            let factor = easing(null, t, 0, 1, duration);
            container.scrollLeft = start + delta * factor;
            if (t < duration && container.scrollLeft != end)
                requestAnimationFrame(tweenLoop);
        }
        tweenLoop();
    },

    easeOutCubic: function (x, t, b, c, d) { return c*((t=t/d-1)*t*t + 1) + b; },
}

export default shops;


// WEBPACK FOOTER //
// ./src/scripts/components/shops.js